import * as React from 'react';
import { useSelector } from 'react-redux';

import { FiltersButtonContainer } from './FiltersButton';
import { ListingButtonContainer } from './ListingButton';
import { SaveSearchButtonContainer } from './SaveSearchButton';
import { Navigation, NavigationButtons } from '../../components/Navigation';
import { selectQuickFiltersGroupCEnabled } from '../../selectors/experiments/selectQuickFiltersExperimentEnabled';

export const NavigationMobileContainer: React.FC = () => {
  const isQuickFiltersGroupCEnabled = useSelector(selectQuickFiltersGroupCEnabled);

  if (isQuickFiltersGroupCEnabled) {
    return (
      <Navigation indent="redesign">
        <FiltersButtonContainer />
        <ListingButtonContainer />
      </Navigation>
    );
  }

  return (
    <Navigation indent="L">
      <NavigationButtons indent="M">
        <FiltersButtonContainer />
        <SaveSearchButtonContainer />
      </NavigationButtons>
    </Navigation>
  );
};

NavigationMobileContainer.displayName = 'NavigationMobileContainer';
